<template>
  <div class="container">
    
    <input id="inline-form-input-name"
      class="inputmessage mb-6 mr-sm-6 mb-sm-0" v-model="text" required placeholder="Enter name: what changed ?"/>
      
    <b-button type='button'  variant="primary" @click="saveMySurvey">Save Changes</b-button>
    
    <div id="surveyCreatorContainer"></div>
  </div>
</template>

<script>
import * as SurveyCreator from "survey-creator";
import "survey-creator/survey-creator.css";
import {BACKEND_URL} from "../variables"
import * as SurveyKo from "survey-knockout";
import * as widgets from "surveyjs-widgets";
import { init as customWidget } from "../components/customwidget";
import Axios from "axios";

// widgets.icheck(SurveyKo);
widgets.select2(SurveyKo);
widgets.inputmask(SurveyKo);
widgets.jquerybarrating(SurveyKo);
widgets.jqueryuidatepicker(SurveyKo);
widgets.nouislider(SurveyKo);
widgets.select2tagbox(SurveyKo);
widgets.sortablejs(SurveyKo);
widgets.ckeditor(SurveyKo);
widgets.autocomplete(SurveyKo);
widgets.bootstrapslider(SurveyKo);
customWidget(SurveyKo);

SurveyKo.Serializer.addProperty("question", "tag:number");

var CkEditor_ModalEditor = {
  afterRender: function (modalEditor, htmlElement) {
    var editor = window["CKEDITOR"].replace(htmlElement);
    editor.on("change", function () {
      modalEditor.editingValue = editor.getData();
    });
    editor.setData(modalEditor.editingValue);
  },
  destroy: function (modalEditor, htmlElement) {
    var instance = window["CKEDITOR"].instances[htmlElement.id];
    if (instance) {
      instance.removeAllListeners();
      window["CKEDITOR"].remove(instance);
    }
  },
};
SurveyCreator.SurveyPropertyModalEditor.registerCustomWidget(
  "html",
  CkEditor_ModalEditor
);
// SurveyCreator.StylesManager.applyTheme("darkblue");

var curStrings = SurveyCreator.editorLocalization.getLocale("");
curStrings.ed.jsonEditor="Ensofia Json"
curStrings.ed.designer="Ensofia Designer"
curStrings.ed.testSurvey="Preview"
curStrings.ed.logic="Logic"
curStrings.ed.saveSurvey="Save for now"
curStrings.ed.settings="Settings"
curStrings.ed.survey="Form"
curStrings.ed.surveyResults="Form Results"
curStrings.ed.surveyResultsTable="Form Results Table"
curStrings.ed.surveyResultsJson="Form Results Json"


export default {
  name: "survey-creator",
  data() {
    return {
      surveyCreator: "" ,
      text:""};
  },
  
  methods: {
    saveMySurvey: function () {
      console.log(this.surveyCreator.text);
      debugger
      // console.log(JSON.stringify(this.text));

      var vm = this;
      // $.ajax({
      //   url: URL + "/form/" + FORM_ID_PDF,
      //   type: "PUT",
      //   data: {
      //     questions: vm.surveyCreator.text
      //   },
      //   success: function(data) {
      //      //callback(saveNo, true);
      //   },
      //   error: function(xhr, ajaxOptions, thrownError) {
      //      //callback(saveNo, false);
      //     alert(thrownError);
      //   }
      // });
      var formData = new FormData();

      formData.append("questions",  vm.surveyCreator.text);
      formData.append("name",  vm.text);

      Axios.put(BACKEND_URL+"form/" + this.$route.params.id, formData)
        .then((response) => {
          console.log(response);
          vm.text=""
          alert("Saved")
          debugger
        })
        .catch((err) => {
          // alert(err);
          // reject(err);
          debugger
        });
    },
    getForm: function (json) {
      var formData = new FormData();
      var vm = this;
      var oldv = json;
      if (this.notifications) this.notifications = [];
      Axios.get(
        BACKEND_URL+"form/" + this.$route.params.id,
        formData,
        {
          headers: {
            enctype: "multipart/form-data",
            authorization: "Bearer " + localStorage.token,
          },
        }
      ).then(
        (response) => {
          console.log(response.data.questions);
          json.text  = response.data.questions;
        },
        (response) => {
          this.notifications.push({
            type: "error",
            message: "Form not created",
          });
        }
      );
    },
  },
  mounted() {
    debugger

    let options = {
      // showEmbededSurveyTab: true,
      showTranslationTab: true,
      showLogicTab: true,

      showState: true,
      haveCommercialLicense: true,
      generateValidJSON: true,
      showOptions: true,
      showSave: true,
    };

    this.surveyCreator = new SurveyCreator.SurveyCreator(
      "surveyCreatorContainer",
      options
    );
    this.surveyCreator.saveSurveyFunc = function () {
      console.log(JSON.stringify(this.text));
    };
     this.getForm(this.surveyCreator);

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.inputmessage{
  width: 70%
}
</style>



// WEBPACK FOOTER //
// SurveyCreator.vue?ec6db14a